// extracted by mini-css-extract-plugin
export default {"backBtn":"ThemePermissions_backBtn__aqm4L","actionBtn":"ThemePermissions_actionBtn__oP2bi"};